import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from './client'

export type ColumnConfig = {
  order: string[]
  hidden: string[]
  /** Per-column pixel widths (columnId → px), set by dragging the header edge. */
  widths?: Record<string, number>
}

const ROOT = '/column-configs'
const KEY = ['column-configs'] as const

type ConfigsResp = { configs: Record<string, ColumnConfig> }

export function useColumnConfigs() {
  const api = useApi()
  return useQuery({
    queryKey: KEY,
    queryFn: () => api<ConfigsResp>(ROOT),
    staleTime: 5 * 60 * 1000,
  })
}

export function useSaveColumnConfig() {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: { tableKey: string; config: ColumnConfig }) =>
      api<{ tableKey: string; config: ColumnConfig }>(`${ROOT}/${input.tableKey}`, {
        method: 'PUT',
        body: input.config,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  })
}
